import { ENDPOINTS } from "@/app/configs/endpoint-config";
import type { FullUser } from "@/entities/user";
import { apiRequest } from "@/api/core";

export type SettingsResponse = {
  devToken?: string;
  createManifest?: boolean;
};

export async function fetchSettings(signal?: AbortSignal) {
  const [settings, error] = await apiRequest<SettingsResponse>({
    method: "GET",
    path: ENDPOINTS.settings,
    signal,
  });

  if (!error && settings) {
    return settings;
  }

  return null;
}

type GetFullUserProps = {
  token: string;
};

export async function getFullUser({ token }: GetFullUserProps) {
  const [user, error] = await apiRequest<FullUser>({
    method: "POST",
    path: ENDPOINTS.getFullUser,
    headers: {
      Authorization: `Bearer ${token}`,
    },
    body: {},
  });

  if (!error && user) {
    return user;
  }

  return null;
}
